@if (fieldData().readonly) {
    <cipo-text-view [config]="fieldData()" [value]="control().value" />
} @else {
    <div class="cipo--width--full">
        <mat-form-field
            appearance="outline"
            class="cipo--width--full"
            [ngClass]="{
                'cipo-mark-changed': fieldData().markChanged && valueChanged(),
            }">
            @if (fieldData().label) {
                <mat-label>{{ fieldData().label | translate }}</mat-label>
            }
            @let allowDragAndDrop = fieldData().allowDragAndDrop ?? false;
            <mat-chip-grid
                #chipGrid
                [formControl]="control()"
                cdkDropList
                cdkDropListOrientation="mixed"
                (cdkDropListDropped)="drop($event)">
                @for (option of control().value; track option) {
                    <mat-chip-row
                        (removed)="remove(option)"
                        [value]="option"
                        [disabled]="!isRemovable(option)"
                        [removable]="isRemovable(option)"
                        cdkDrag
                        [cdkDragDisabled]="!allowDragAndDrop">
                        @if (allowDragAndDrop) {
                            <mat-icon matChipAvatar>drag_indicator</mat-icon>
                        }
                        {{ optionsDict()[option] || option | translate }}
                        @if (isRemovable(option)) {
                            <button
                                matChipRemove
                                [attr.aria-label]="
                                    'a11y.form.removeChip' | translate: { value: optionsDict()[option] || option }
                                ">
                                <mat-icon aria-hidden="true">cancel</mat-icon>
                            </button>
                        }
                    </mat-chip-row>
                }
            </mat-chip-grid>
            <input
                [value]="searchCriteria()"
                (input)="searchCriteria.set($any($event.target).value)"
                [matChipInputFor]="chipGrid"
                [matAutocomplete]="auto"
                [placeholder]="fieldData().placeholder | translate"
                #chipInput
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)" />
            <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="selected($event); chipInput.value = ''"
                (opened)="loadDataSource()">
                @if (!fieldData().options && fieldData().dataSourceInfo) {
                    <mat-option disabled>{{ "general.loadingMessage" | translate }}</mat-option>
                }
                @for (option of availableOptions(); track option.key) {
                    <mat-option [value]="option.key" [disabled]="option.isDisabled">
                        @if (!option?.description) {
                            {{ option.value | translate }}
                        } @else {
                            <div fxLayout="column">
                                <span>{{ option.value | translate }}</span>
                                <span class="cipo-text--black-400">{{ option.description | translate }}</span>
                            </div>
                        }
                    </mat-option>
                }
            </mat-autocomplete>
            @if (fieldData().suffix) {
                <button
                    matSuffix
                    mat-icon-button
                    type="button"
                    class="cipo--text-size--sm m-r-xs"
                    [attr.aria-label]="fieldData().suffix"
                    (click)="suffixClickedHandler($event)">
                    {{ fieldData().suffix }}
                </button>
            }
            @if (control().invalid && control().touched) {
                <mat-error>
                    {{ control().hasError("custom") ? control().errors.custom : ("errors.required" | translate) }}
                </mat-error>
            }
            @if (fieldData().hint) {
                <mat-hint>{{ fieldData().hint | translate }}</mat-hint>
            }
        </mat-form-field>
    </div>
}
